import React, { FC, ReactNode } from 'react'
import { InputText } from '../InputText';

export interface InputDateProperties {
    id?: string;
    name?: string;
    className?: string;
    label: string;
    format?: string;
    value?: any;
    defaultValue?: string;
    pattern?: string;
    size?: "small" | "medium";
    fullWidth: boolean;
    error?: boolean;
    disabled?: boolean;
    readonly?: boolean;
    margin?: "normal" | "dense" | "none";
    type?: "date" | "datetime-local";
    prefix?: ReactNode;
    onKeyPress?: Function;
    onKeyUp?: Function;
    onKeyDown?: Function;
    onBlur?: Function;
    onFocus?: Function;
    onChange?: (date: string | null) => void,
}

const InputDate: FC<InputDateProperties> = ({
    name,
    className,
    id = "input-date",
    type = "date",
    label,
    value,
    defaultValue,
    size,
    fullWidth = true,
    error = false,
    readonly = false,
    disabled = false,
    margin,
    prefix,
    onKeyPress,
    onKeyUp,
    onKeyDown,
    onBlur,
    onFocus,
    onChange,
}) => {
    return <>
        <InputText
            id={id}
            name={name}
            className={className}
            label={label}
            margin={margin}
            value={value}
            defaultValue={defaultValue}
            size={size}
            fullWidth={fullWidth}
            disabled={disabled}
            readonly={readonly}
            error={error}
            prefix={prefix}
            type={type}
            onChange={(event: any) => {
                if (onChange) {
                    onChange(event.target.value)
                }
            }}

        >
        </InputText>
        {/* <Menu
                keepMounted
                open={position.mouseY !== null}
                onClose={handleClose}
                anchorReference="anchorPosition"
                anchorPosition={
                    position.mouseY !== null && position.mouseX !== null ? { top: position.mouseY, left: position.mouseX } : undefined
                }
            >
                <MenuItem onClick={() => handleDate(0)}>Hoje</MenuItem>
                <MenuItem onClick={() => handleDate(1)}>Ontem</MenuItem>
                <MenuItem onClick={() => handleDate(2)}>Amanhã</MenuItem>
                <Divider />
                <MenuItem onClick={() => handleDate(10)}>Inicio do mês anterior</MenuItem>
                <MenuItem onClick={() => handleDate(11)}>Final do mês anterior</MenuItem>
                <Divider />
                <MenuItem onClick={() => handleDate(20)}>Inicio do mês</MenuItem>
                <MenuItem onClick={() => handleDate(21)}>Final do mês</MenuItem>
                <Divider />
                <MenuItem onClick={() => handleDate(30)}>Inicio do próximo mês</MenuItem>
                <MenuItem onClick={() => handleDate(31)}>Final do próximo mês</MenuItem>
                <Divider />
                <MenuItem onClick={() => handleDate(40)}>Início do ano</MenuItem>
                <MenuItem onClick={() => handleDate(41)}>Final do ano</MenuItem>
                <Divider />
                <MenuItem onClick={() => handleDate(99)}>Limpar</MenuItem>
            </Menu> */}
    </>
}

export { InputDate }